// Dependencies
import React from 'react';
import { m } from 'framer-motion';

// Material UI Components
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';

// Internal Components
import Iconify from './Iconify';
import { varFade } from './animate';

export default function GoTop() {
  // ============================
  // State
  const [goTopHidden, setGoTopHidden] = React.useState(true);
  const [dragging, setDragging] = React.useState(false);

  // ============================
  // Hooks
  const theme = useTheme();

  // ============================
  // Refs
  const timeOutRef = React.useRef<NodeJS.Timeout | null>(null);

  // ============================
  // Handlers
  const handleVisibleButton = () => {
    const position = window.scrollY;
    if (position >= 300) {
      setGoTopHidden(false);
    } else {
      setGoTopHidden(true);
    }
  };

  // ============================
  // Effects
  React.useEffect(() => {
    window.addEventListener('scroll', handleVisibleButton);
    return () => {
      window.removeEventListener('scroll', handleVisibleButton);
      if (timeOutRef.current) {
        clearTimeout(timeOutRef.current);
      }
    };
  }, []);

  // ============================
  // Render
  if (goTopHidden) return null;

  return (
    <m.div
      variants={varFade().in}
      style={{
        position: 'fixed',
        bottom: 16,
        left: theme.direction === 'ltr' ? undefined : 16,
        right: theme.direction === 'ltr' ? 16 : undefined,
        zIndex: 1000,
      }}
      drag
      onDragStart={() => {
        setDragging(true);
      }}
      onDragEnd={() => {
        timeOutRef.current = setTimeout(() => {
          setDragging(false);
        }, 300);
      }}
      dragConstraints={{
        top: -100,
        left: theme.direction === 'ltr' ? -100 : 0,
        right: theme.direction === 'ltr' ? 0 : 100,
        bottom: 0,
      }}
      //   dragSnapToOrigin
      dragElastic={0.1}
      dragMomentum={false}
      dragTransition={{ bounceStiffness: 600, bounceDamping: 10 }}
    >
      <IconButton
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (!dragging) window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
      >
        <Iconify icon="eva:arrow-upward-fill" width={24} height={24} />
      </IconButton>
    </m.div>
  );
}
